import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';


@Injectable()
export class PessoalService {
    urlObterQuestoes: string;
    codigoModuloPessoal = 4;
    analiseAtual: any = null;
    idPaginaPessoal: string = "960";
    resumoAnalise: any;

    constructor(public http: HttpClient,
        private gestaoPcaService: GestaoPcaService,
        private utilService: UtilService) {
    }

    public obterIdPaginaPessoal() {
        return this.idPaginaPessoal;
    }

    // Analista

    // Análise 1
    public obterAnaliseHorizontal(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarAnaliseHorizontal(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarAnaliseHorizontal(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 1

    // Análise 2
    public obterAnaliseVertical(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/2/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarAnaliseVertical(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/2/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarAnaliseVertical(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/2/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 2

    // Análise 3
    public obterPessoalVersusNomeacao(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/3/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarPessoalVersusNomeacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/3/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarPessoalVersusNomeacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/3/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 3

    // Análise 4
    public obterNomeacaoVersusSRP(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/4/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarNomeacaoVersusSRP(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/4/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarNomeacaoVersusSRP(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/4/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 4

    // Análise 5
    public obterTermosReferenciaContrato(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/5/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarTermosReferenciaContrato(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/5/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarTermosReferenciaContrato(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/5/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 5

    // Análise 6
    public obterNomeacaoVersusParametrizacao(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/6/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarNomeacaoVersusParametrizacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/6/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarNomeacaoVersusParametrizacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/6/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 6

    // Análise 7
    public obterQuadroPessoal(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/7/listar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public finalizarQuadroPessoal(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/7/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarQuadroPessoal(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/7/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim análise 7


    // Visao Gerencial

    public obterVisaoGerencial(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/obterVisaoGerencialPessoal?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarVisaoGerencial(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/salvarVisaoGerencial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=100";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarVisaoGerencial(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/finalizarVisaoGerencial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=100";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterVisaoGerencialPessoalElemento31(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/obterVisaoGerencialPessoalElemento31?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarVisaoGerencialElemento31(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/salvarVisaoGerencialElemento31?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=114";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarVisaoGerencialElemento31(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/finalizarVisaoGerencialElemento31?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=114";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    // Fim Visao Gerencial


    public obterListaAnalises(codModulo): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // Fim Analista

    // Jurisdicionado

    public obterListaAnalisesJur(codModulo): Observable<any> {
        this.urlObterQuestoes = "pessoal?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // Demonstrativo do Quadro de Pessoal
    public listarDemonstrativoQuadroPessoal(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarDemonstrativoQuadroPessoal/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarDemonstrativoQuadroPessoal(idDemonstrativo): Observable<any> {
        this.urlObterQuestoes = "pessoal/deletarDemonstrativoQuadroPessoal/" + idDemonstrativo;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public salvarDemonstrativoQuadroPessoal(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/salvarDemonstrativoQuadroPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarDemonstrativoQuadroPessoal(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/finalizarDemonstrativoQuadroPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Fim Demonstrativo do Quadro de Pessoal

    // Quadro de Nomeação de Cargos
    public listarQuadroNomeacao(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarQuadroNomeacao/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarQuadroNomeacaoAnterior(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarQuadroNomeacaoAnterior/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarQuadroNomeacao(idQuadro): Observable<any> {
        this.urlObterQuestoes = "pessoal/deletarQuadroNomeacao/" + idQuadro;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }
    
    public deletarLista(jsonList): Observable<any> {
        this.urlObterQuestoes = "pessoalExclusao/excluirLista";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonList);
    }

    public salvarQuadroNomeacao(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/salvarQuadroNomeacao/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarQuadroNomeacao(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/finalizarQuadroNomeacao/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public baixarTemplatePreenchido(isAnterior) {
        var headers = new HttpHeaders();
        headers.append('responseType', 'arraybuffer');
        return this.utilService.getJSON("pessoal/baixarQuadroNomeacao/" + this.gestaoPcaService.getPCA().id + "?isAnterior=" + isAnterior);
      }
    // Quadro de Nomeação de Cargos

    // Quantitativo de Pessoal
    public listarQuantitativoPessoal(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarQuantitativoPessoal/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarQuantitativoPessoal(idQuantitativo): Observable<any> {
        this.urlObterQuestoes = "pessoal/deletarQuantitativoPessoal/" + idQuantitativo;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public salvarQuantitativoPessoal(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/salvarQuantitativoPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarQuantitativoPessoal(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/finalizarQuantitativoPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }
    // Quantitativo de Pessoal

    // Termos de Referência Contratos
    public listarReferenciaContratos(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarReferenciaContratos/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarReferenciaContratos(idReferencia): Observable<any> {
        this.urlObterQuestoes = "pessoal/deletarReferenciaContratos/" + idReferencia;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public deletarReferenciaContratosAtribuicao(idAtribuicao): Observable<any> {
        this.urlObterQuestoes = "pessoal/deletarReferenciaContratosAtribuicao/" + idAtribuicao;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public salvarReferenciaContratos(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/salvarReferenciaContratos/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarReferenciaContratos(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "pessoal/finalizarReferenciaContratos/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public importarReferenciaContratos(): Observable<any> {
        this.urlObterQuestoes = "pessoal/importarReferenciaContratos/" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, null);
    }
    // Termos de Referência Contratos

    // Fim Jurisdicionado


    // Arquivo Pessoal

    // public downloadArquivoPessoal(idArquivoTec): Observable<any> {
    //     this.urlObterQuestoes = "arquivoPessoal/download/" + idArquivoTec;
    //     return this.utilService.getJSON(this.urlObterQuestoes);
    // }

    public downloadfile(path: string, jsonArquivo: any) {
        var headers = new HttpHeaders();
        headers.append('responseType', 'arraybuffer');
        this.utilService.getJSON(path)
            .subscribe(data => {
                let contentType = "data:" + data.mimeType + ";base64";

                let byteCharacters = atob(data.decodedFile);

                let byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: contentType });
                saveAs(file, jsonArquivo.nmArquivo);
            },
                error => console.log("Error downloading the file. error: " + error));
    }

    public downloadArquivoPessoal(jsonArquivo) {
        if (jsonArquivo.idArquivoContratoTerceirizacao != 0) {
            this.urlObterQuestoes = "arquivoPessoal/download/" + jsonArquivo.idArquivoContratoTerceirizacao;
            this.downloadfile(this.urlObterQuestoes, jsonArquivo);
        } //else {
        //   this.urlObterQuestoes = "arquivoPessoal/downloadTemp?idPca=" + this.gestaoPcaService.getPCA().id + "&nmArquivo=" + jsonArquivo.nmArquivoTemp;
        //   this.downloadfile(this.urlObterQuestoes, jsonArquivo);
        // }
    }

    public deletarArquivoPessoal(jsonArquivo): Observable<any> {
        this.urlObterQuestoes = "arquivoPessoal/deletar/" + jsonArquivo.idArquivoContratoTerceirizacao;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    // public salvarArquivoPessoal(jsonObjeto): Observable<any> {
    //     this.urlObterQuestoes = "arquivoPessoal/salvar/" + this.gestaoPcaService.getPCA().id;
    //     return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    // }

    public salvarArquivoPessoal(event) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            let formData: FormData = new FormData();
            formData.append('arquivoEvidencia', file, file.name);
            let envioRolXml: string = "arquivoPessoal/salvar/" + this.gestaoPcaService.getPCA().id;
            return this.utilService.postArquivo(envioRolXml, formData);
        }
    }

    public downloadTemplateArquivoPessoal(idTipoTemplate): Observable<any> {
        this.urlObterQuestoes = "arquivoPessoal/downloadTemplate/" + idTipoTemplate;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // Fim Arquivo Pessoal

    // Parametrizacao

    public listarParametrizacao(): Observable<any> {
        this.urlObterQuestoes = "cargoSetor/listar";
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarParametrizacao(idCargoSetor): Observable<any> {
        this.urlObterQuestoes = "cargoSetor/deletar/" + idCargoSetor;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public salvarParametrizacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "cargoSetor/salvar";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public importarParametrizacao(idCargoSetor): Observable<any> {
        this.urlObterQuestoes = "cargoSetor/buscar/" + idCargoSetor;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // Fim Parametrizacao

    // Auxiliares

    public listarGrupoCargo(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarGrupoCargo ";
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarSetor(): Observable<any> {
        this.urlObterQuestoes = "pessoal/listarSetor ";
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // Fim Auxiliares

    public obterPessoalCertificado(): Observable<any> {
        this.urlObterQuestoes = "analisePessoal/1/obterPreviewCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public submeterAnaliseNoCertificado(idAnalise, dadosAnalise): Observable<any> {

        this.resumoAnalise = {
            idModuloAnalise: dadosAnalise.idModuloAnalise,
            dsResultadoAnalise: dadosAnalise.resultadoAnalise,
            idStatusAnalise: 0,
            dsStatusAnalise: "",
            idModuloPca: 0,
            cdAnalise: 0,
            dsDescricaoAnalise: ""
        };

        this.urlObterQuestoes = "licitacao/submterAnalise";
        return this.utilService.postJSON(this.urlObterQuestoes, this.resumoAnalise);
    }
}



// WEBPACK FOOTER //
// ./src/providers/pessoal-service.ts